export const ActionTypes = {
    CHANGE_LANG: "CHANGE_LANG"
};

export const changeLang = lang => ({
    type: ActionTypes.CHANGE_LANG,
    lang: lang
  })
